import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseHttpService } from './base.http.service';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { IEnvironmentConfig } from 'src/app/models/environmentConfig';
import { LegalEntityInstructionFieldQueryModel, LegalEntityInstructionUpdateModel } from 'src/app/models/investorUpdate';
import { DocumentTypes } from 'src/app/models/documentTypes';
import { LegalEntityInstructionUpdateResponse } from 'src/app/models/investorUpdate';

@Injectable()
export class LegalEntityInstructionService extends BaseHttpService {
    constructor(private http: HttpClient, private appConfig: AppConfig) {
        super();
    }
    
    get envSettings(): IEnvironmentConfig {
        return this.appConfig.getEnvironmentConfig();
    }

    public saveInvestorDetailsUpdateInstruction(investorDetails: LegalEntityInstructionUpdateModel): Observable<LegalEntityInstructionUpdateResponse> {
        const url = `${this.envSettings.webApiUrl}legalentity/instruction/investor`;
        const jsonBody = JSON.stringify(investorDetails);
        return this.http.post<LegalEntityInstructionUpdateResponse>(url, jsonBody, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public saveMemberDetailsUpdateInstruction(memberDetails: LegalEntityInstructionUpdateModel): Observable<LegalEntityInstructionUpdateResponse> {
        const url = `${this.envSettings.webApiUrl}legalentity/instruction/member`;
        const jsonBody = JSON.stringify(memberDetails);
        return this.http.post<LegalEntityInstructionUpdateResponse>(url, jsonBody, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public saveMemberDetailsTaxResidenceUpdateInstruction(memberDetails: LegalEntityInstructionUpdateModel): Observable<LegalEntityInstructionUpdateResponse> {
        const url = `${this.envSettings.webApiUrl}legalentity/instruction/member/taxResidence`;
        const jsonBody = JSON.stringify(memberDetails);
        return this.http.post<LegalEntityInstructionUpdateResponse>(url, jsonBody, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public saveLegalEntityDetailsUpdateInstructionDocument(file: File, legalEntityId: number, instructionId: number, documentType: DocumentTypes): Observable<any> {
        const formData = new FormData();
    
        formData.append('file', file, file.name);
    
        const url = `${this.envSettings.webApiUrl}legalentity/${legalEntityId}/instruction/${instructionId}/document/${documentType}`;
        return this.http.post(url, formData, {
                headers: this.getHttpHeadersWithoutContentType(),
                observe: 'response'
        });
    }

    public getLegalEntityUpdateInstructions(requestModel: LegalEntityInstructionFieldQueryModel):Observable<any> {
        const url = `${this.envSettings.webApiUrl}legalentity/instruction/search`;
        const jsonBody = JSON.stringify(requestModel);
        return this.http.post(url, jsonBody, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public cancelLegalEntityUpdateInstruction(legalEntityId: number, instructionId: number): Observable<any> {
        const url = `${this.envSettings.webApiUrl}legalentity/${legalEntityId}/instruction/${instructionId}/cancel`;
        return this.http.post(url, "", {
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }
}
